import BuildingType from '@/roc/building/BuildingType';
import BuildingMaxLevel from '@/roc/building/BuildingMaxLevel';
import Effects from '@/roc/effects/Effects';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const HeavyInfantryBarracks = {
  id: '10',
  name: 'Heavy Infantry Barracks',
  width: 5,
  height: 5,
  type: BuildingType.BARRACKS,
  era: 'classicGreece',
  icon: 'HeavyInfantry',
  minLevel: 4,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Barracks/Heavy_Infantry_Barracks',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: null,
    minoanEra: null,
    classicGreece: 1,
    earlyRome: 1,
    romanEmpire: 1,
    byzantineEra: 1,
    ageOfTheFranks: 1,
    feudalAge: 1,
    iberianEra: 1,
    kingdomOfSicily: 1,
    highMiddleAges: 1,
    earlyGothicEra: 1,
    lateGothicEra: 1,
  },
  effects: Effects.create([
    new Happiness({
      stoneAge: null,
      bronzeAge: null,
      minoanEra: null,
      classicGreece: [400, 800, 1600],
      earlyRome: [500, 1000, 2000],
      romanEmpire: [600, 1200, 2400],
      byzantineEra: [700, 1400, 2800],
      ageOfTheFranks: [850, 1700, 3400],
      feudalAge: [1000, 2000, 4000],
      iberianEra: [1200, 2400, 4800],
      kingdomOfSicily: [1450, 2900, 5800],
      highMiddleAges: [1750, 3500, 7000],
      earlyGothicEra: [2100, 4200, 8400],
      lateGothicEra: [2500, 5000, 10000],
    })
  ]),
};

export default HeavyInfantryBarracks;
